import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { initialValues, onSubmit, validationSchema } from './changeProfileFormikCodes';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import GetField from '../../components/GetField';
import { getSingleAdminService } from '../../services/usersServices';
import Alert from '../../utils/Alert';
import { useNavigate } from 'react-router-dom';


const ChangeProfile = () => {
    const [adminData, setAdminData] = useState(null);
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const navigate = useNavigate();

    const { userId } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

    const handleGetDataOfAdmin = async (adminId) => {
        try {
            const response = await getSingleAdminService(adminId);
            if (response.status === 200) {
                setAdminData(response.data);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        handleGetDataOfAdmin(userId);
    }, []);

    useEffect(() => {
        if (adminData) {
            setReinitializeValues({
                name: adminData.name,
                family: adminData.family,
                phone_number: adminData.phone_number,
                email: adminData.email,
                address: adminData.address,
                address_code: adminData.address_code,
            });
        } else {
            setReinitializeValues(null);
        }
    }, [adminData]);

    return (
        <Formik
            initialValues={reinitializeValues || initialValues}
            onSubmit={(values, actions) => onSubmit(values, actions, userId)}
            validationSchema={validationSchema}
            enableReinitialize
            validateOnMount
        >
            {(formik) => {
                return (
                    <Form className="flex flex-col items-center
                    max-w-screen-sm mx-auto px-1 py-2">
                        <div className="w-full text-center">
                            <ManageAccountsRoundedIcon sx={{
                                fontSize: "2.5rem"
                            }} />
                        </div>
                        <h1 className="w-full text-center mb-6 text-lg">
                            ویرایش اطلاعات
                        </h1>
                        <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="name"
                                type="text"
                                placeholder="نام"
                                label="نام"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="family"
                                type="text"
                                placeholder="نام خانوادگی"
                                label="نام خانوادگی"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="phone_number"
                                type="text"
                                placeholder="شماره تلفن"
                                label="شماره تلفن"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-6 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="email"
                                type="text"
                                placeholder="ایمیل"
                                label="ایمیل"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="textarea"
                                name="address"
                                placeholder="آدرس"
                                label="آدرس:"
                                rows={2}
                            />
                        </div>
                        <div className="mb-7 w-full md:w-4/6 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="address_code"
                                type="text"
                                placeholder="کد پستی"
                                label="کد پستی"
                                formik={formik}
                            />
                        </div>
                        <div className="w-full text-center mt-4">
                            <GetField
                                control="submitbutton"
                                disabledButton={true}
                                formik={formik}
                                text="ثبت اطلاعات"
                            />
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default ChangeProfile;
